import http from "@/services/http";
import {useAuth} from "@/services/auth.js";

export const formasDePagamento = () => {
  const auth = useAuth();

  async function list() {
    let retorno;
    try {
        const {data} = await http.get('/payment-methods', auth.getBearer());
        retorno = data;
      } catch (error) {
        console.log(error?.response?.data);
      }
    return retorno;
  }

  async function createItem(metodo) {
    try {
      await http.post('/payment-methods', metodo, auth.getBearer());
      return true;
    } catch (error) {
      console.log(error?.response?.data);
      return false;
    }
  }

  async function updateItem(metodo) {
    try {
      await http.put('/payment-methods/'+metodo.id, metodo, auth.getBearer());
      return true;
    } catch (error) {
      console.log(error?.response?.data);
      return false;
    }
  }

  async function deleteItem(id) {
    try {
      await http.delete('/payment-methods/'+id, auth.getBearer());
      return true;
    } catch (error) {
      return error?.response?.data?.message ?? false;
    }
  }

  return {list, createItem, updateItem, deleteItem}
}
